export default __webpack_public_path__ + "static/room-layout-619d8244353fea4cd4b024bf27f12e5c.png";